import { render, staticRenderFns } from "./settingBase.vue?vue&type=template&id=5f9b3a22&scoped=true&"
import script from "./settingBase.vue?vue&type=script&lang=js&"
export * from "./settingBase.vue?vue&type=script&lang=js&"
import style0 from "./settingBase.vue?vue&type=style&index=0&id=5f9b3a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b3a22",
  null
  
)

export default component.exports